import { render, staticRenderFns } from "./MergeButton.vue?vue&type=template&id=02ad0791&scoped=true&"
import script from "./MergeButton.vue?vue&type=script&lang=js&"
export * from "./MergeButton.vue?vue&type=script&lang=js&"
import style0 from "./MergeButton.vue?vue&type=style&index=0&id=02ad0791&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ad0791",
  null
  
)

export default component.exports